<template>
    <div class="table-container lb-alternative-font">
        <!--button
      v-t="'Sessions.refresh'"
      :class="{ 'is-loading': refreshing }"
      class="button"
      @click="fetchRanking"
        ></button-->
        <table class="table is-striped is-hoverable is-fullwidth">
            <thead>
                <th v-t="'Sessions.ranking_name'"></th>
                <th v-t="'Sessions.ranking_score'"></th>
                <th v-t="'Sessions.ranking_progress'"></th>
            </thead>
            <transition-group name="flip-list" tag="tbody">
                <tr v-for="participant in participants" :key="participant._id">
                    <td>
                        <article class="level">
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="image is-24x24">
                                        <img
                                            :src="participant.avatar"
                                            referrerpolicy="no-referrer"
                                            class="is-rounded"
                                        />
                                    </p>
                                </div>
                                <div class="level-item">
                                    <p
                                        class="lb-alternative-font has-text-weight-bold"
                                    >{{ participant.alias || participant.username }}</p>
                                </div>
                            </div>
                        </article>
                    </td>
                    <td>{{ participant.score }}</td>
                    <td>
                        <progress
                            :value="participant.progress || 0"
                            max="100"
                            class="progress is-small is-primary"
                        >{{ participant.progress || 0 }}</progress>
                    </td>
                </tr>
            </transition-group>
        </table>
    </div>
</template>

<script>
import { RootAPI as API } from '@/services/API';
import { groupBy } from 'underscore';
export default {
    components: {},
    data() {
        return {
            updateInterval: null,
            participants: [],
            refreshing: false,
        };
    },
    computed: {},
    mounted() {
        this.fetchRanking();
        this.updateInterval = setInterval(this.fetchRanking, 5000);
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
    },
    methods: {
        fetchRanking() {
            if (this.refreshing) {
                return;
            }
            this.refreshing = true;
            const scoresByParticipant = groupBy(
                this.$store.state.session.scores,
                (score) => score.owner.owner
            );
            API.get(`V1/session/${this.$store.state.session._id}/ranking`)
                .then((result) => {
                    this.participants = result.data.map((participant) => {
                        if (!scoresByParticipant[participant.owner]) {
                            participant.progress = 0;
                        } else {
                            participant.progress =
                                (scoresByParticipant[participant.owner].length /
                                    this.$store.getters.questions.length) *
                                100;
                        }
                        return participant;
                    });
                })
                .finally(() => {
                    this.refreshing = false;
                });
        },
    },
};
</script>

<style scoped>
.flip-list-move {
    transition: transform 1s;
}
</style>
